import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FormulaVersion } from "@/shared/models/FormulaVersion";
import { CustomerDeterminant } from "../shared/models/CustomerDeterminant";
import { FiscalPeriod } from "../shared/models/ProductionDeterminantListing";
import { CustomerMinimal } from "../shared/models/CustomerMinimal";
import { FormulaType } from "../shared/models/FormulaType";

const initialState = {
  // search from backend by user selected formulversion id, query from db by id
  formula: undefined as FormulaVersion | undefined,
  customerDeterminants: undefined as CustomerDeterminant | undefined,
  productionDeterminants: undefined as any,
  selectedSurchargeType: "",
  selectedFormulaType: undefined as FormulaType | undefined,
  // current user selected formula version, from formula version list, formula version list is queryed from DB by type id
  selectedFormulaVersion: undefined as FormulaVersion | undefined,
  selectedFiscalMonth: undefined as FiscalPeriod | undefined,
  selectedCustomer: {} as CustomerMinimal,
};

const formulaSimulatorSlice = createSlice({
  name: "formulaSimulator",
  initialState: initialState,
  reducers: {
    resetformulaSimulator(state) {
      state.formula = undefined;
      state.customerDeterminants = undefined;
      state.productionDeterminants = undefined;
      state.selectedSurchargeType = "";
      state.selectedFormulaType = undefined;
      state.selectedFormulaVersion = undefined;
      state.selectedFiscalMonth = undefined;
      state.selectedCustomer = {} as CustomerMinimal;
    },
    setFormula(state, action) {
      state.formula = action.payload;
    },
    setCustomerDeterminants(state, action) {
      state.customerDeterminants = action.payload;
    },
    setProductionDeterminants(state, action) {
      state.productionDeterminants = action.payload;
    },
    setSelectedSurchargeType(state, action) {
      state.selectedSurchargeType = action.payload;
    },
    setSelectedFormulaType(state, action) {
      state.selectedFormulaType = action.payload;
    },
    setSelectedFormulaVersion(state, action) {
      state.selectedFormulaVersion = action.payload;
    },
    setSelectedFiscalMonth(state, action) {
      state.selectedFiscalMonth = action.payload;
    },
    setSelectedCustomer(state, action) {
      state.selectedCustomer = action.payload;
    },
    updateFormulaCalculationString(state, action: PayloadAction<string>) {
      if (state.formula) state.formula!.calculationString = action.payload;
    },
  },
});

export const {
  resetformulaSimulator,
  setFormula,
  setCustomerDeterminants,
  setProductionDeterminants,
  setSelectedSurchargeType,
  setSelectedFormulaType,
  setSelectedFormulaVersion,
  setSelectedFiscalMonth,
  setSelectedCustomer,
  updateFormulaCalculationString,
} = formulaSimulatorSlice.actions;
export const formulaSimulatorReducer = formulaSimulatorSlice.reducer;

// Selector
export const selectFormula = (state: any) => state.formulaSimulator.formula as FormulaVersion;
export const selectCustomerDeterminants = (state: any) => state.formulaSimulator.customerDeterminants;
export const selectProductionDeterminants = (state: any) => state.formulaSimulator.productionDeterminants;
export const selectSelectedSurchargeType = (state: any) => state.formulaSimulator.selectedSurchargeType as string;
export const selectSelectedFormulaType = (state: any) => state.formulaSimulator.selectedFormulaType as FormulaType;
export const selectSelectedFormulaVersion = (state: any) => state.formulaSimulator.selectedFormulaVersion as FormulaVersion;
export const selectselectedFiscalMonth = (state: any) => state.formulaSimulator.selectedFiscalMonth as FiscalPeriod;
export const selectselectedCustomer = (state: any) => state.formulaSimulator.selectedCustomer as CustomerMinimal;
